import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useLayoutEffect, useState, useCallback, } from 'react';
var ThemeContext = createContext(undefined);
var DEFAULT_STORAGE_KEY = 'lift-theme';
export function ThemeProvider(_a) {
    var children = _a.children, _b = _a.defaultTheme, defaultTheme = _b === void 0 ? 'light' : _b, _c = _a.storageKey, storageKey = _c === void 0 ? DEFAULT_STORAGE_KEY : _c;
    var _d = useState(function () {
        if (typeof window === 'undefined')
            return defaultTheme;
        try {
            var stored = localStorage.getItem(storageKey);
            if (stored === 'light' || stored === 'dark')
                return stored;
        }
        catch (_a) {
            // localStorage may be unavailable (SSR, iframe sandbox, etc.)
        }
        return defaultTheme;
    }), theme = _d[0], setThemeState = _d[1];
    // useLayoutEffect so the dark class lands inside flushSync during view transitions
    // (useEffect is too late — VT would snapshot the wrong theme).
    useLayoutEffect(function () {
        var root = document.documentElement;
        if (theme === 'dark') {
            root.classList.add('dark');
        }
        else {
            root.classList.remove('dark');
        }
        try {
            localStorage.setItem(storageKey, theme);
        }
        catch (_a) {
            // silent fail
        }
    }, [theme, storageKey]);
    var setTheme = useCallback(function (newTheme) {
        // Sync class immediately for callers that don't go through layout effects.
        document.documentElement.classList.toggle('dark', newTheme === 'dark');
        setThemeState(newTheme);
    }, []);
    var toggleTheme = useCallback(function () {
        setThemeState(function (prev) { return (prev === 'light' ? 'dark' : 'light'); });
    }, []);
    return (_jsx(ThemeContext.Provider, { value: { theme: theme, setTheme: setTheme, toggleTheme: toggleTheme }, children: children }));
}
export function useTheme() {
    var context = useContext(ThemeContext);
    if (!context) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return context;
}
